

export default function TextSearchRoom (){
    return(
        <p className="text-sm text-black222 leading-tight text-left || mt-c5 mb-6">
          Search rooms, entire homes and more. Total prices shown for one night
          before taxes.
        </p>
    )
}